import { GetSubsribedUsersToNewsResponse } from '@seesignage/seesignage-utils'
import { CsvScreen } from '../types/screens'

export const generateCsvStr = (header: string[], rows: string[][]) => {
  const csvHeader = header.join()
  const csvRows = rows.join('\n')
  const csvStr = `${csvHeader}\n${csvRows}`
  return csvStr
}

export const downloadFile = (url: string, fileName: string) => {
  const hiddenElement = document.createElement('a')
  hiddenElement.href = url
  hiddenElement.target = '_blank'
  hiddenElement.download = fileName
  hiddenElement.click()
}

export const generateScreensCsv = (screens: CsvScreen[]) => {
  const csvHeader = ['Näytön nimi', 'Koodi', 'Suunta', 'Tunniste', 'Malli']
  const csvRows = screens.map(({ name, code, rotation, identifier, productNumber }) => [
    name.replace(/,/g, ''),
    code || '',
    rotation === 0 ? 'vaaka' : 'pysty',
    identifier || '',
    productNumber
  ])
  return generateCsvStr(csvHeader, csvRows)
}

export const downloadCsvFile = (csvStr: string, fileName: string) => {
  const csvURI = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvStr)
  return downloadFile(csvURI, fileName)
}

export const generateSubscribersToNewsLetterListCsv = (
  subscribersList: GetSubsribedUsersToNewsResponse
) => {
  const csvHeader = ['Name', 'Email']
  const csvRows = subscribersList.map(({ name, email }) => [name, email])
  return generateCsvStr(csvHeader, csvRows)
}
